import MowerAttribute from "./MowerAttribute";

const MowerAttributeContainer = (props: any) => {

    const {
        catalogItemValues,
        setCatalogItemValues,
        catalogItemErrors,
        validateCatalogItemValues
    } = props


    const handleOnChange = (value: any, name: string) => {
        if (value) {
            setCatalogItemValues((prev: any) => ({ ...prev, [name]: value }))
            validateCatalogItemValues(value, name)
        }
    }

    return (
        <MowerAttribute
            {...props}
            catalogItemValues={catalogItemValues}
            handleOnChange={handleOnChange}
            catalogItemErrors={catalogItemErrors}
            filterName={props.filterName}
            setFilterName={props.setFilterName}
            filterModelPopup={props.filterModelPopup}
            onPopupFilterModel={props.onPopupFilterModel}
            setFilterModelPopup={props.setFilterModelPopup}
        />
    )
}

export default MowerAttributeContainer